import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '密桃视频',
    url: window.location.origin,
    description: '密桃视频提供香蕉视频、糖豆视频等热门平台高清影视资源，全集免费在线观看不缓冲，小蓝视频、蓝莓视频最新电影电视剧大全每日更新。',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'service@mitao.com',
      availableLanguage: ['Chinese'],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '密桃视频是否需要付费观看？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '密桃视频所有内容均为免费观看，无需任何付费。我们聚合香蕉视频、糖豆视频等平台资源，为用户提供全集免费在线观看服务。',
        },
      },
      {
        '@type': 'Question',
        name: '观看视频为什么不会缓冲？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '密桃视频采用先进的CDN加速技术和智能码率自适应方案，根据您的网络状况自动调整清晰度，确保流畅不缓冲的观影体验。',
        },
      },
      {
        '@type': 'Question',
        name: '密桃视频支持哪些设备观看？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '密桃视频支持电脑、平板、手机等主流设备，无需下载APP，通过浏览器即可直接观看高清视频内容。',
        },
      },
      {
        '@type': 'Question',
        name: '视频更新频率是怎样的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们每日更新最新电影和电视剧资源，涵盖香蕉视频、糖豆视频、小蓝视频、蓝莓视频等多个平台的热门内容，确保您不会错过任何精彩。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系密桃视频？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过邮箱 service@mitao.com 与我们取得联系，我们会在24小时内回复您的咨询和建议。',
        },
      },
    ],
  };

  const stats = [
    { value: '10万+', label: '影视资源' },
    { value: '5000万+', label: '月活跃用户' },
    { value: '99.9%', label: '播放成功率' },
    { value: '4.9', label: '用户评分' },
  ];

  const testimonials = [
    {
      name: '张先生',
      avatar: '张',
      comment: '密桃视频真的太方便了，一个网站就能看多个平台的资源，而且完全不卡顿，画质也很清晰。',
      rating: 5,
    },
    {
      name: '李女士',
      avatar: '李',
      comment: '自从用了密桃视频，再也不用在多个APP之间切换了。追剧体验提升了一大截，强烈推荐！',
      rating: 5,
    },
    {
      name: '王同学',
      avatar: '王',
      comment: '更新速度很快，基本上新剧播出第二天就能在密桃视频上看到了，而且免费不用开会员。',
      rating: 5,
    },
    {
      name: '赵女士',
      avatar: '赵',
      comment: '分类很清晰，找片很方便。而且移动端观看体验也很好，在地铁上追剧完全不卡。',
      rating: 4,
    },
  ];

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <Breadcrumb
        items={[
          { label: '首页', path: '/' },
          { label: '关于我们' },
        ]}
      />

      <div className="max-w-5xl mx-auto px-4 md:px-6 pb-10">

        {/* Hero */}
        <section className="py-8 md:py-12 text-center">
          <h1 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900">
            关于密桃视频
          </h1>
          <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            密桃视频是一个聚合型高清影视在线观看平台，汇聚香蕉视频、糖豆视频、小蓝视频、蓝莓视频等多个热门平台的优质影视资源，
            致力于为广大用户提供全集免费、高清流畅、不缓冲的观影体验。
          </p>
        </section>

        {/* Stats */}
        <section className="py-8 md:py-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="text-center p-6 rounded-lg bg-background-100 border border-background-200/70"
              >
                <div className="text-2xl md:text-3xl font-bold font-heading text-accent-600">
                  {stat.value}
                </div>
                <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Brand Introduction */}
        <section className="py-8 md:py-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-6">
            品牌介绍
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-base font-semibold text-foreground-800 mb-3">我们的使命</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                密桃视频成立于2024年，我们的使命是让每个人都能轻松享受高质量的影视内容。
                通过聚合多平台资源，我们打破了平台壁垒，让用户可以一站式浏览和观看来自香蕉视频、糖豆视频、小蓝视频、蓝莓视频等平台的精彩内容。
              </p>
            </div>
            <div>
              <h3 className="text-base font-semibold text-foreground-800 mb-3">核心优势</h3>
              <ul className="space-y-2">
                {[
                  { icon: 'ri-shield-check-line', text: '多平台资源聚合，一站式观影体验' },
                  { icon: 'ri-speed-up-line', text: '智能CDN加速技术，播放流畅不缓冲' },
                  { icon: 'ri-hd-line', text: '高清画质自适应，匹配最佳观看效果' },
                  { icon: 'ri-refresh-line', text: '每日实时更新，最新影视资源一手掌握' },
                  { icon: 'ri-money-cny-circle-line', text: '完全免费，无需注册，无需付费' },
                ].map((item) => (
                  <li key={item.text} className="flex items-start gap-2 text-sm text-foreground-600">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5 text-accent-600">
                      <i className={`${item.icon} w-4 h-4 flex items-center justify-center`} />
                    </span>
                    {item.text}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/* Reputation / Testimonials */}
        <section className="py-8 md:py-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-6">
            用户口碑
          </h2>
          <div className="grid sm:grid-cols-2 gap-4">
            {testimonials.map((t) => (
              <div
                key={t.name}
                className="p-5 rounded-lg bg-background-100 border border-background-200/70"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center text-accent-700 font-semibold text-sm">
                    {t.avatar}
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-800">{t.name}</div>
                    <div className="flex items-center gap-0.5">
                      {Array.from({ length: 5 }, (_, i) => (
                        <i
                          key={i}
                          className={`w-3 h-3 flex items-center justify-center ${
                            i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-fill text-foreground-200'
                          }`}
                        />
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  &ldquo;{t.comment}&rdquo;
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* Contact */}
        <section className="py-8 md:py-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-6">
            联系我们
          </h2>
          <div className="grid md:grid-cols-3 gap-4">
            <div className="p-5 rounded-lg bg-background-100 border border-background-200/70 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-mail-line text-xl w-6 h-6 flex items-center justify-center" />
              </div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h4>
              <a href="mailto:service@mitao.com" className="text-sm text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap">
                service@mitao.com
              </a>
            </div>
            <div className="p-5 rounded-lg bg-background-100 border border-background-200/70 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-customer-service-line text-xl w-6 h-6 flex items-center justify-center" />
              </div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-1">在线客服</h4>
              <p className="text-sm text-foreground-500">工作日 9:00 - 18:00</p>
            </div>
            <div className="p-5 rounded-lg bg-background-100 border border-background-200/70 text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-feedback-line text-xl w-6 h-6 flex items-center justify-center" />
              </div>
              <h4 className="text-sm font-semibold text-foreground-800 mb-1">意见反馈</h4>
              <p className="text-sm text-foreground-500">欢迎随时提出宝贵意见</p>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-8 md:py-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-6">
            常见问题
          </h2>
          <div className="space-y-3">
            {[
              { q: '密桃视频是否需要付费观看？', a: '密桃视频所有内容均为免费观看，无需任何付费。我们聚合多平台资源，为用户提供全集免费在线观看服务。' },
              { q: '观看视频为什么不会缓冲？', a: '密桃视频采用先进的CDN加速技术和智能码率自适应方案，根据您的网络状况自动调整清晰度，确保流畅不缓冲的观影体验。' },
              { q: '密桃视频支持哪些设备观看？', a: '密桃视频支持电脑、平板、手机等主流设备，无需下载APP，通过浏览器即可直接观看高清视频内容。' },
              { q: '视频更新频率是怎样的？', a: '我们每日更新最新电影和电视剧资源，涵盖多个平台的热门内容，确保您不会错过任何精彩。' },
              { q: '如何联系密桃视频？', a: '您可以通过邮箱 service@mitao.com 与我们取得联系，我们会在24小时内回复您的咨询和建议。' },
            ].map((faq, idx) => (
              <details
                key={idx}
                className="group rounded-lg bg-background-100 border border-background-200/70"
              >
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm font-medium text-foreground-800">
                  {faq.q}
                  <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center transition-transform group-open:rotate-180 text-foreground-400" />
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                  {faq.a}
                </div>
              </details>
            ))}
          </div>
        </section>

      </div>
    </>
  );
}